import React from 'react';
import { DollarSign } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';

const CurrencySwitcher = () => {
  const { currency, setCurrency } = useCurrency();

  return (
    <button
      onClick={() => setCurrency(currency === 'AZN' ? 'USD' : 'AZN')}
      className="flex items-center gap-2 px-3 py-2 text-[13px] font-medium tracking-wider text-gray-700 hover:text-black transition-colors border border-gray-300 rounded hover:border-black"
    >
      <DollarSign className="w-4 h-4" />
      <span>{currency}</span>
    </button>
  );
};

export default CurrencySwitcher;
